import { useState } from "react";

import type { DeliveryPopup } from "modules/AppointmentDetails/components/VehicleTyres/hooks";

const tyreDeliveries = [
  {
    id: "Standard",
    order_before: "",
    delivery_before: "",
    delivery_from: ""
  }
];

const getDeliveriesOptions = () => [
  {
    key: "Standard",
    value: "Standard",
    text: "Standard delivery"
  }
];

const getDeliveryChannelName = () => "TyreNET";

const getDeliveryPopup = (): DeliveryPopup => {
  return {
    trigger: "Standard",
    content: "Standard",
    long: "Standard"
  };
};

export const useTyreNet = () => {
  const [selectedDeliveryIds, setSelectedDeliveryIds] = useState<string[]>(["Standard"]);

  return {
    selectedDeliveryIds,
    setSelectedDeliveryIds,
    tyreDeliveries,
    isLoadingTyreDeliveries: false,
    getDeliveriesOptions,
    getDeliveryChannelName,
    getDeliveryPopup
  };
};
